'use client'

import type { ReactNode } from 'react'
import { RowSurfaceProvider } from '@/deskUiSkeletons/rowTemplates/RowSurfaceContext'
import type { RowSurface } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'
import { SubRow } from '@/deskUiSkeletons/subs/SubRow'
import { showQuickReplyModal } from '@/deskUiSkeletons/Shared/QuickReplyModal'
import { rowVariantRegistry } from '@/stdDesk/rowTemplates/RowTemplateRegistry'
import { nestedTemplateVariant } from '@/stdDesk/rowTemplates/RowTemplateConfig'
import { rowSkin } from '@/stdDesk/rowTemplates/RowTemplateSkin'

// Std wiring for the shared row skeleton: the surface leaves the skeleton
// reads through the RowSurface seam (25_SHARED_DESKUI_SKELETON.md §5).

const stdRowSurface: RowSurface = {
  SubRow,
  showQuickReplyModal,
  variants: rowVariantRegistry,
  config: { nestedTemplateVariant },
  skin: rowSkin,
}

export function StdRowSurfaceProvider({ children }: { children: ReactNode }) {
  return <RowSurfaceProvider value={stdRowSurface}>{children}</RowSurfaceProvider>
}
